import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../utils/QAPlogo-Photoroom.png";

const LINKS = [
  { to: "/generate", label: "Generate" },
  { to: "/companies", label: "Companies" },
  { to: "/profile", label: "Profile" },
];

function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setMenuOpen(false); // close mobile menu on desktop
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const linkClass = ({ isActive }) =>
    isActive ? "nav-link active" : "nav-link";

  return (
    <nav className="navbar">
      <img
        src={logo}
        alt="QAP Financials"
        className="nav-logo"
        onClick={() => navigate("/dashboard")}
        style={{ cursor: "pointer" }}
      />

      {/* ===== DESKTOP NAV ===== */}
      {!isMobile && (
        <div className="navbar-right">
          {LINKS.map(({ to, label }) => (
            <NavLink key={to} to={to} className={linkClass}>
              {label}
            </NavLink>
          ))}
        </div>
      )}

      {/* ===== MOBILE NAV ===== */}
      {isMobile && (
        <>
          <div
            className="mobile-menu-btn"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            ☰
          </div>

          {menuOpen && (
            <div className="mobile-menu">
              {LINKS.map(({ to, label }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={linkClass}
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </NavLink>
              ))}
            </div>
          )}
        </>
      )}
    </nav>
  );
}

export default Navbar;
